import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd003-card-III',
    templateUrl: './cd003-card-III.component.html'
})

export class Cd003CardIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listPreSabPed?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPreSem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listPreSabPedOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPreSemOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    @Output() mkCalc = new EventEmitter();
    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Análise da Amostra Prévia (Antes da Primeira Passada) e Análise de Defeitos na Fração Semente boa a cada passada', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                quebradas_g: [null, []],
                quebradas_severas_g: [null, []],
                ardidas_g: [null, []],
                ardidas_severas_g: [null, []],
                furadas_leves_g: [null, []],
                furadas_severas_g: [null, []],
                furadas_lagarta_g: [null, []],
                furadas_percevejo_g: [null, []],
                furadas_roedores_g: [null, []],
                silk_cut_g: [null, []],
                silk_cut_severas_g: [null, []],
                popped_kernel_severas_g: [null, []],
                popped_kernel_g: [null, []],
                inerte_g: [null, []],
                presenca_sabugo_ou_pedunculo: [null, []],
                presenca_outras_sementes_especies: [null, []],
                total_defeitos_prc: [null, []],
                total_defeitos_leves_prc: [null, []],
                total_defeitos_severos_prc: [null, []],
                resultado_descriminado_caso_reprovado: [null, []],
                resultado: [null, []],
            });

        } else {
            this.formulario = this.formBuilder.group({
                quebradas_g: [null, [Validators.required]],
                quebradas_severas_g: [null, [Validators.required]],
                ardidas_g: [null, [Validators.required]],
                ardidas_severas_g: [null, [Validators.required]],
                furadas_leves_g: [null, [Validators.required]],
                furadas_severas_g: [null, [Validators.required]],
                //furadas_lagarta_g: [null, [Validators.required]],
                //furadas_percevejo_g: [null, [Validators.required]],
                //furadas_roedores_g: [null, [Validators.required]],
                //silk_cut_g: [null, [Validators.required]],
                //silk_cut_severas_g: [null, [Validators.required]],
                popped_kernel_severas_g: [null, [Validators.required]],
                popped_kernel_g: [null, [Validators.required]],
                inerte_g: [null, [Validators.required]],
                presenca_sabugo_ou_pedunculo: [null, [Validators.required]],
                presenca_outras_sementes_especies: [null, [Validators.required]],
                total_defeitos_prc: [null, [Validators.required]],
                total_defeitos_leves_prc: [null, [Validators.required]],
                total_defeitos_severos_prc: [null, [Validators.required]],
                resultado_descriminado_caso_reprovado: [null, []],
                resultado: [null, []],
            });
        }


    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();

    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListPreSabPed(), this.getListPreSem()]);
    }

    async getListPreSabPed(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'ultima_carga').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listPreSabPed = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listPreSabPedOriginal = this.listPreSabPed;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, 'Erro para buscar do banco de dados para montagem da lista de Presença de Sabugo ou Pedúnculo');
        });
    }

    async getListPreSem(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'ultima_carga').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listPreSem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listPreSemOriginal = this.listPreSem;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, 'Erro para buscar do banco de dados para montagem da lista de Presença de Outras Sementes (Espécies)');
        });
    }

    createFilterPreSabPed(value?: string): void {
        if (!!value && value.length > 0) {
            if (this.listPreSabPedOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPreSabPed = this.listPreSabPedOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPreSabPed = this.listPreSabPedOriginal;
            }
        } else {
            this.listPreSabPed = this.listPreSabPedOriginal;
        }
        // this.filteredOptionsPreSabPed = this.formulario.get('presenca_sabugo_ou_pedunculo').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listPreSabPed, value))
        //     );
    }

    createFilterPreSem(value?: string): void {
        if (!!value && value.length > 0) {
            if (this.listPreSemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPreSem = this.listPreSemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPreSem = this.listPreSemOriginal;
            }
        } else {
            this.listPreSem = this.listPreSemOriginal;
        }
        // this.filteredOptionsPreSem = this.formulario.get('presenca_outras_sementes_especies').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listPreSem, value))
        //     );
    }
    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();

    }
}

